import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { Suspense } from "react";
import BayesianOptimizationInputs from "./BayesianOptimizationInputs";
import Loader from "../../../../../../Components/Loader";
import FinetuningDataset from "./FinetuningDataset";
import { inputStyles } from "../../../../../../Constants/inputStyles";
import theme from "../../../../../../Constants/theme";

const FinetuningNode = ({
  LLMFinetuning,
  handleLLMSelectClick,
  selectRefLLM,
  llm_select,
  handleLLMSelectChange,
  llm_select_open,
  setllm_select_open,
  llm_select_options,
  handleOpmSelectClick,
  selectRefOPM,
  opm_select,
  handleOpmSelectChange,
  opm_select_open,
  setopm_select_open,
  opm_select_options,
  botData,
  setBotData,
  nodeId,
  batchSize,
  handleBatchSize,
  learningRate,
  handleLearningRateChange,
  learningRateM,
  handleLearningRateMultiplierChange,
  rank,
  handleRankChange,
  aplhaRankRatio,
  handleAlphaRankRatio,
  epoch,
  handleEpochChange,
  organization,
  data,
}) => {
  return (
    <Tooltip
      // title={
      //   organization?.organization?.subscription === "starter" &&
      //   !organization?.organization?.llm_keys?.openai_key?.key &&
      //   organization?.organization?.pinecone_key?.key &&
      //   "You need Pro subscription to access this feature or provide your own keys in settings."
      // }
      title={"Fine-tuning is an Enterprise feature."}
    >
      <Box
        sx={{
          opacity: LLMFinetuning ? "1" : "0.7",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "row",
          width: "100%",
          gap: 2,
        }}
        data-tour="option-2e"
      >
        <Box
          sx={{
            width: "60%",
            border: `1px solid ${theme.border.light}`,
            borderRadius: "10px",
            padding: "10px",
          }}
        >
          <FormControl
            disabled={!LLMFinetuning}
            fullWidth
            variant="outlined"
            size="medium"
            onClick={handleLLMSelectClick}
            sx={{ marginBottom: 2, marginTop: 2 }}
          >
            <InputLabel
              sx={inputStyles.inputLabel}
              disabled={!LLMFinetuning}
              id="llm-select-label"
              onClick={handleLLMSelectClick}
            >
              Select Model for Fine-tuning
            </InputLabel>
            <Select
              disabled={!LLMFinetuning}
              inputRef={selectRefLLM}
              labelId="llm-select-label"
              label="Select Model for Fine-tuning"
              value={llm_select}
              onChange={handleLLMSelectChange}
              open={llm_select_open}
              onClose={() => setllm_select_open(false)}
              sx={inputStyles.select}
            >
              {llm_select_options.map((option) => (
                <MenuItem
                  key={option}
                  value={option}
                  disabled={
                    option === "llama-3-8b" &&
                    organization?.organization?.subscription === "starter" &&
                    organization?.organization?.llm_keys?.openai_key?.key &&
                    organization?.organization?.pinecone_key?.key
                  }
                  onClick={(event) => {
                    event.stopPropagation();
                    handleLLMSelectChange(event);
                  }}
                >
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl
            disabled={!LLMFinetuning}
            fullWidth
            variant="outlined"
            size="medium"
            onClick={handleOpmSelectClick}
            sx={{
              marginBottom: 2,
              marginTop: 2,
              cursor: LLMFinetuning ? "text" : "not-allowed",
            }}
          >
            <InputLabel
              disabled={!LLMFinetuning}
              id="opm-select-label"
              onClick={handleOpmSelectClick}
              sx={inputStyles.label}
            >
              Select Optimization Method for Fine-tuning
            </InputLabel>
            <Select
              disabled={!LLMFinetuning}
              inputRef={selectRefOPM}
              labelId="opm-select-label"
              label="Select Optimization Method for Fine-tuning"
              value={opm_select}
              onChange={handleOpmSelectChange}
              open={opm_select_open}
              onClose={() => setopm_select_open(false)}
              sx={{
                cursor: LLMFinetuning ? "text" : "not-allowed",
                ...inputStyles.select,
              }}
            >
              {opm_select_options.map((option) => (
                <MenuItem
                  key={option}
                  value={option}
                  onClick={(event) => {
                    event.stopPropagation();
                    handleOpmSelectChange(event);
                  }}
                >{`${
                  option === "grid-search"
                    ? "Grid Search"
                    : "Bayesian Optimization"
                }`}</MenuItem>
              ))}
            </Select>
          </FormControl>

          {opm_select === "bayesian-optimization" ? (
            <Suspense fallback={<Loader />}>
              <BayesianOptimizationInputs
                botData={botData}
                setBotData={setBotData}
                llm_select={llm_select}
                nodeId={nodeId}
              />{" "}
            </Suspense>
          ) : (
            <Suspense fallback={<Loader />}>
              <TextField
                disabled={!LLMFinetuning}
                fullWidth
                label="Epoch"
                value={epoch}
                onChange={handleEpochChange}
                sx={{
                  marginBottom: 2,
                  marginTop: 2,
                  cursor: LLMFinetuning ? "text" : "not-allowed",
                  ...inputStyles.textField,
                  "& .MuiInputLabel-root": {
                    color: theme.inputs.textColor,
                    fontSize: "13px",
                  },
                }}
              />

              <TextField
                disabled={!LLMFinetuning}
                label="Batch Size"
                fullWidth
                value={batchSize}
                onChange={handleBatchSize}
                sx={{
                  marginBottom: 2,
                  marginTop: 2,
                  cursor: LLMFinetuning ? "text" : "not-allowed",
                  ...inputStyles.textField,
                  "& .MuiInputLabel-root": {
                    color: theme.inputs.textColor,
                    fontSize: "13px",
                  },
                }}
              />

              {llm_select === "llama-3-8b" ? (
                <TextField
                  disabled={!LLMFinetuning}
                  fullWidth
                  label="Learning Rate (0 - 0.1)"
                  type="text"
                  value={learningRate}
                  onChange={handleLearningRateChange}
                  sx={{
                    marginBottom: 2,
                    cursor: LLMFinetuning ? "text" : "not-allowed",
                    ...inputStyles.textField,
                    "& .MuiInputLabel-root": {
                      color: theme.inputs.textColor,
                      fontSize: "13px",
                    },
                  }}
                />
              ) : (
                <TextField
                  disabled={!LLMFinetuning}
                  fullWidth
                  label="Learning Rate Multiplier (Greater than 0)"
                  type="text"
                  value={learningRateM}
                  onChange={handleLearningRateMultiplierChange}
                  sx={{
                    marginBottom: 2,
                    cursor: LLMFinetuning ? "text" : "not-allowed",
                    ...inputStyles.textField,
                    "& .MuiInputLabel-root": {
                      color: theme.inputs.textColor,
                      fontSize: "13px",
                    },
                  }}
                />
              )}

              {llm_select === "llama-3-8b" && (
                <div className="qlora-container">
                  <Typography sx={{ color: theme.textColors.dark.primary }}>
                    QLoRA parameters
                  </Typography>
                  <TextField
                    fullWidth
                    label="Rank (Greater than 1)"
                    type="text"
                    value={rank}
                    onChange={handleRankChange}
                    sx={{
                      marginBottom: 2,
                      marginTop: 2,
                      ...inputStyles.textField,
                      "& .MuiInputLabel-root": {
                        color: theme.inputs.textColor,
                        fontSize: "13px",
                      },
                    }}
                  />
                  <TextField
                    fullWidth
                    label="Alpha/Rank"
                    type="text"
                    value={aplhaRankRatio}
                    onChange={handleAlphaRankRatio}
                    sx={{
                      marginBottom: 2,
                      ...inputStyles.textField,
                      "& .MuiInputLabel-root": {
                        color: theme.inputs.textColor,
                        fontSize: "13px",
                      },
                    }}
                  />
                </div>
              )}
            </Suspense>
          )}
        </Box>

        <Box
          sx={{
            border: `1px solid ${theme.border.light}`,
            borderRadius: "10px",
            padding: "10px",
            width: "50%",
          }}
        >
          <FinetuningDataset
            nodeId={nodeId}
            botData={botData}
            setBotData={setBotData}
            showSnackbar={data.showSnackbar}
            LLMFinetuning={LLMFinetuning}
          />
        </Box>
      </Box>
    </Tooltip>
  );
};

export default FinetuningNode;
